export class DigestType {
  name: string;
  value: number;
  reqLength: number;
}

export const DIGESTTYPES = {
  SHA1:  {name: 'SHA1', value: 1, reqLength: 40},
  SHA256: {name: 'SHA256', value: 2, reqLength: 64},
  GOSTR341194: {name: 'GOSTR341194', value: 3, reqLength: 64},
  SHA384: {name: 'SHA384', value: 4, reqLength: 96}
};
